(function () {
  Array.prototype.slice.call(document.querySelectorAll('.main-nav a, .mobile-menu a')).forEach(function (link) {
    if (link.textContent.trim().toLowerCase() === 'why befores') {
      link.setAttribute('href', '/pages/why-befores');
    }
  });
  if (document.querySelector('.wb-hero')) {
    document.documentElement.classList.add('why-befores-page');
    if (window.location.hash === '#routine') {
      window.setTimeout(function () {
        var routine = document.querySelector('#routine');
        if (routine) routine.scrollIntoView({ behavior: 'auto', block: 'start' });
      }, 120);
    }
  }

  Array.prototype.slice.call(document.querySelectorAll('a[href="/pages/why-befores#routine"]')).forEach(function (link) {
    link.addEventListener('click', function (event) {
      var target = document.querySelector('#routine');
      if (!target || !document.querySelector('.wb-hero')) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      history.replaceState(null, '', '/pages/why-befores#routine');
    });
  });

  Array.prototype.slice.call(document.querySelectorAll('.shopify-policy__body .rte h1')).forEach(function (heading) {
    var replacement = document.createElement('h2');
    replacement.innerHTML = heading.innerHTML;
    Array.prototype.slice.call(heading.attributes).forEach(function (attribute) {
      replacement.setAttribute(attribute.name, attribute.value);
    });
    heading.parentNode.replaceChild(replacement, heading);
  });
})();

(function () {
  function setCartCount(count) {
    Array.prototype.slice.call(document.querySelectorAll('[data-cart-count]')).forEach(function (badge) {
      badge.textContent = count;
      badge.classList.toggle('is-hidden', !count);
    });
  }

  window.beforesSetCartCount = setCartCount;

  window.beforesUpdateCartCount = function () {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        setCartCount(cart.item_count || 0);
        return cart;
      });
  };

  window.beforesUpdateCartCount().catch(function () {});
})();

(function () {
  var preloader = document.querySelector('[data-preloader]');
  if (!preloader) return;

  var started = Date.now();
  var minimum = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 120 : 650;

  function hidePreloader() {
    var elapsed = Date.now() - started;
    var wait = Math.max(minimum - elapsed, 0);

    window.setTimeout(function () {
      preloader.classList.add('is-hiding');
      window.setTimeout(function () {
        if (preloader.parentNode) {
          preloader.parentNode.removeChild(preloader);
        }
      }, 360);
    }, wait);
  }

  if (document.readyState === 'complete') {
    hidePreloader();
  } else {
    window.addEventListener('load', hidePreloader, { once: true });
  }
})();

(function () {
  var header = document.querySelector('.site-header');
  if (!header) return;

  function updateHeader() {
    header.classList.toggle('is-scrolled', window.scrollY > 12);
  }

  updateHeader();
  window.addEventListener('scroll', updateHeader, { passive: true });
})();

(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var ticking = false;

  function updateAmbient() {
    ticking = false;
    var y = window.scrollY || 0;
    var max = Math.max(document.documentElement.scrollHeight - window.innerHeight, 1);
    document.documentElement.style.setProperty('--ambient-scroll', Math.round(y * -0.09) + 'px');
    document.documentElement.style.setProperty('--scroll-progress', Math.min(y / max, 1).toFixed(4));
  }

  function requestAmbient() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(updateAmbient);
  }

  updateAmbient();
  window.addEventListener('scroll', requestAmbient, { passive: true });
})();

(function () {
  if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var groups = [
    '.story-text',
    '.story-main',
    '.mission-image',
    '.mission-text',
    '.prepare .section-intro',
    '.product-copy',
    '.why img',
    '.why-copy',
    '.routine > h2',
    '.faq .section-intro',
    '.faq-list',
    '.closer .check-list',
    '.closer img',
    '.site-footer'
  ];
  var items = Array.prototype.slice.call(document.querySelectorAll(groups.join(',')));
  if (!items.length) return;

  items.forEach(function (item, index) {
    item.classList.add('js-reveal');
    if (index % 2) item.classList.add('js-reveal-delay');
  });

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.16, rootMargin: '0px 0px -8% 0px' });

  items.forEach(function (item) {
    observer.observe(item);
  });
})();

(function () {
  var showcase = document.querySelector('[data-prepare-showcase]');
  if (!showcase) return;

  var pin = showcase.querySelector('.prepare-pin');
  var slider = showcase.querySelector('.prepare-slider');
  var slides = Array.prototype.slice.call(showcase.querySelectorAll('.prepare-slide'));
  var mediaQuery = window.matchMedia('(min-width: 981px)');
  var activeIndex = 0;
  var ticking = false;
  var sceneActive = false;
  var gestureConsumed = false;
  var gestureTimer = null;
  var sliderStartOffset = slider.offsetTop - showcase.offsetTop;
  var stickyY = null;
  var firstStickyY = null;
  var pendingDownEntry = false;
  var lastScrollY = window.scrollY;

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function resetSlides() {
    showcase.classList.remove('is-scroll-driven');
    activeIndex = 0;
    sceneActive = false;
    gestureConsumed = false;
    stickyY = null;
    firstStickyY = null;
    pendingDownEntry = false;
    lastScrollY = window.scrollY;
    slides.forEach(function (slide, index) {
      slide.classList.toggle('is-active', index === 0);
      slide.style.opacity = '';
      slide.style.transform = '';
      slide.style.visibility = '';
    });
  }

  function getSliderRange() {
    var start = stickyY === null ? showcase.offsetTop + sliderStartOffset : stickyY;
    var end = pin.offsetTop + pin.offsetHeight - window.innerHeight;
    return { start: start, end: Math.max(end, start + 1) };
  }

  function sliderIsSticky() {
    var sliderRect = slider.getBoundingClientRect();
    var pinRect = pin.getBoundingClientRect();
    return sliderRect.top <= 3 && pinRect.top <= 0 && pinRect.bottom >= window.innerHeight - 8;
  }

  function rememberStickyPosition() {
    if (stickyY === null && sliderIsSticky()) {
      stickyY = window.scrollY;
      if (firstStickyY === null) firstStickyY = stickyY;
    }
  }

  function lockToSlider(range) {
    var target = stickyY === null ? range.start : stickyY;
    if (Math.abs(window.scrollY - target) > 1) {
      window.scrollTo(0, target);
    }
  }

  function setActiveSlide(index) {
    activeIndex = clamp(index, 0, slides.length - 1);
    showcase.classList.add('is-scroll-driven');

    slides.forEach(function (slide, slideIndex) {
      var isActive = slideIndex === activeIndex;
      slide.classList.toggle('is-active', isActive);
      slide.style.opacity = isActive ? '1' : '0';
      slide.style.visibility = isActive ? 'visible' : 'hidden';
      slide.style.transform = isActive ? 'translateY(0)' : 'translateY(' + (slideIndex < activeIndex ? '-22px' : '26px') + ')';
    });
  }

  function consumeWheel(event) {
    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }
  }

  function markGestureConsumed() {
    gestureConsumed = true;
    window.clearTimeout(gestureTimer);
    gestureTimer = window.setTimeout(function () {
      gestureConsumed = false;
    }, 180);
  }

  function handleWheel(event) {
    return;
    if (!mediaQuery.matches || Math.abs(event.deltaY) < 4) return;

    var renderedIndex = slides.findIndex(function (slide) {
      return slide.classList.contains('is-active');
    });
    if (renderedIndex >= 0) activeIndex = renderedIndex;

    var range = getSliderRange();
    var y = window.scrollY;
    var goingDown = event.deltaY > 0;
    var sliderRect = slider.getBoundingClientRect();
    var pinRect = pin.getBoundingClientRect();
    var isStickyNow = sliderIsSticky();
    var catchPoint = window.innerHeight * 0.72;
    var willEnterDown = !isStickyNow && goingDown && sliderRect.top > 0 && (sliderRect.top <= catchPoint || sliderRect.top - Math.abs(event.deltaY) <= catchPoint);
    var willEnterUp = !isStickyNow && !goingDown && y > range.end + 2 && pinRect.bottom < window.innerHeight && pinRect.bottom + Math.abs(event.deltaY) >= window.innerHeight;
    var inSliderRange = isStickyNow || (y >= range.start - 2 && y <= range.end + 2);

    if (!inSliderRange && !willEnterDown && !willEnterUp) return;

    if (gestureConsumed) {
      consumeWheel(event);
      if (inSliderRange) lockToSlider(range);
      markGestureConsumed();
      return;
    }

    if (willEnterDown) {
      consumeWheel(event);
      stickyY = y + sliderRect.top;
      firstStickyY = stickyY;
      sceneActive = true;
      pendingDownEntry = true;
      setActiveSlide(slides.length > 1 ? 1 : 0);
      lockToSlider(range);
      markGestureConsumed();
      return;
    }

    if (willEnterUp) {
      consumeWheel(event);
      stickyY = range.end;
      sceneActive = true;
      setActiveSlide(slides.length - 1);
      lockToSlider(range);
      markGestureConsumed();
      return;
    }

    if (goingDown && activeIndex < slides.length - 1) {
      consumeWheel(event);
      sceneActive = true;
      lockToSlider(range);
      setActiveSlide(activeIndex + 1);
      markGestureConsumed();
      return;
    }

    if (!goingDown && activeIndex > 0) {
      consumeWheel(event);
      sceneActive = true;
      lockToSlider(range);
      setActiveSlide(activeIndex - 1);
      markGestureConsumed();
      return;
    }

    consumeWheel(event);
    sceneActive = false;
    window.scrollTo(0, goingDown ? range.end + 24 : (firstStickyY || showcase.offsetTop + sliderStartOffset) - 24);
    stickyY = null;
    markGestureConsumed();
  }

  function handleScroll() {
    ticking = false;

    if (!mediaQuery.matches) {
      resetSlides();
      return;
    }

    showcase.classList.add('is-scroll-driven');

    var range = getSliderRange();
    var progress = clamp((window.scrollY - range.start) / Math.max(range.end - range.start, 1), 0, 1);
    var nextActive = progress >= 0.22 ? slides.length - 1 : 0;

    if (window.scrollY < range.start - 4) {
      sceneActive = false;
      setActiveSlide(0);
      lastScrollY = window.scrollY;
      return;
    }

    if (window.scrollY > range.end + 4) {
      sceneActive = false;
      setActiveSlide(slides.length - 1);
      lastScrollY = window.scrollY;
      return;
    }

    setActiveSlide(nextActive);
    lastScrollY = window.scrollY;
  }

  function requestUpdate() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(handleScroll);
  }

  function syncWhileVisible() {
    requestUpdate();
    window.requestAnimationFrame(syncWhileVisible);
  }

  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate);
  if (mediaQuery.addEventListener) {
    mediaQuery.addEventListener('change', function () {
      if (showcase.getBoundingClientRect().top > 0) {
        sliderStartOffset = slider.offsetTop - showcase.offsetTop;
      }
      requestUpdate();
    });
  }

  if (mediaQuery.matches) {
    requestUpdate();
    syncWhileVisible();
  } else {
    resetSlides();
  }
})();

(function () {
  var toggle = document.querySelector('[data-menu-toggle]');
  var menu = document.querySelector('[data-mobile-menu]');
  var close = document.querySelector('[data-menu-close]');
  if (!toggle || !menu || !close) return;

  function setMenu(open) {
    document.documentElement.classList.toggle('menu-open', open);
    menu.classList.toggle('is-open', open);
    menu.setAttribute('aria-hidden', open ? 'false' : 'true');
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  toggle.addEventListener('click', function () {
    setMenu(!menu.classList.contains('is-open'));
  });

  close.addEventListener('click', function () {
    setMenu(false);
  });

  menu.addEventListener('click', function (event) {
    if (event.target === menu || event.target.closest('a')) {
      setMenu(false);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      setMenu(false);
    }
  });
})();

(function () {
  var modal = document.querySelector('[data-wholesale-modal]');
  var openers = Array.prototype.slice.call(document.querySelectorAll('[data-wholesale-open]'));
  if (!modal || !openers.length) return;

  var panel = modal.querySelector('.wholesale-modal__panel');
  var form = modal.querySelector('[data-wholesale-form]');
  var file = modal.querySelector('[data-wholesale-file]');
  var fileName = modal.querySelector('[data-wholesale-file-name]');
  var fileLabel = modal.querySelector('[data-wholesale-file-label]');
  var error = modal.querySelector('[data-wholesale-error]');
  var success = modal.querySelector('[data-wholesale-success]');
  var submit = modal.querySelector('.wholesale-form__submit');
  var closers = Array.prototype.slice.call(modal.querySelectorAll('[data-wholesale-close]'));
  var lastFocus = null;

  function setError(message) {
    if (!error) return;
    error.textContent = message || '';
    error.hidden = !message;
  }

  function setSuccess(message) {
    if (!success) return;
    success.textContent = message || '';
    success.hidden = !message;
  }

  function setOpen(state) {
    modal.classList.toggle('is-open', state);
    modal.setAttribute('aria-hidden', state ? 'false' : 'true');
    document.documentElement.classList.toggle('wholesale-open', state);
    if (state) {
      lastFocus = document.activeElement;
      window.setTimeout(function () { if (panel) panel.focus(); }, 60);
    } else if (lastFocus) {
      lastFocus.focus();
    }
  }

  openers.forEach(function (opener) {
    opener.addEventListener('click', function (event) {
      event.preventDefault();
      setOpen(true);
    });
  });

  closers.forEach(function (closer) {
    closer.addEventListener('click', function () {
      setOpen(false);
    });
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && modal.classList.contains('is-open')) {
      setOpen(false);
    }
  });

  if (file) {
    file.addEventListener('change', function () {
      setError('');
      var selected = file.files && file.files[0];
      if (!selected) return;
      if (selected.size > 10 * 1024 * 1024) {
        file.value = '';
      if (fileName) fileName.value = '';
      if (fileLabel) fileLabel.textContent = 'Drag & Drop your file here';
      setError('Please upload a PDF, JPG, or PNG under 10MB.');
        return;
      }
      if (fileName) fileName.value = selected.name;
      if (fileLabel) fileLabel.textContent = selected.name;
    });
  }

  if (form) {
    if (submit) {
      submit.addEventListener('click', function () {
        if (typeof form.checkValidity === 'function' && !form.checkValidity()) {
          setError('Please complete every required field and upload your Tax Resale Certificate.');
        }
      });
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var selected = file && file.files && file.files[0];
      setSuccess('');
      if (!selected) {
        setError('Please upload your Tax Resale Certificate before submitting.');
        return;
      }
      if (selected.size > 10 * 1024 * 1024) {
        setError('Please upload a PDF, JPG, or PNG under 10MB.');
        return;
      }
      setError('');
      if (submit) {
        submit.disabled = true;
        submit.textContent = 'Submitting...';
      }

      fetch(form.getAttribute('action'), {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: new FormData(form)
      }).then(function (response) {
        if (!response.ok) throw new Error('Wholesale submission failed');
        return response.json();
      }).then(function () {
        setSuccess('Thank you. Your wholesale application was submitted with your Tax Resale Certificate attached.');
        form.reset();
        if (fileLabel) fileLabel.textContent = 'Drag & Drop your file here';
      }).catch(function () {
        setError('We could not submit your application. Please try again or email hello@getbefores.com.');
      }).finally(function () {
        if (submit) {
          submit.disabled = false;
          submit.textContent = 'Submit';
        }
      });
    });
  }
})();

(function () {
  var section = document.querySelector('[data-wb-product-section]');
  if (!section) return;

  var form = section.querySelector('[data-wb-product-form]');
  var productJson = section.querySelector('[data-wb-product-json]');
  var product = productJson ? JSON.parse(productJson.textContent) : null;
  var mediaItems = Array.prototype.slice.call(section.querySelectorAll('[data-wb-media]'));
  var mediaThumbs = Array.prototype.slice.call(section.querySelectorAll('[data-wb-media-thumb]'));
  var optionInputs = Array.prototype.slice.call(section.querySelectorAll('[data-wb-option]'));
  var variantInput = section.querySelector('[data-wb-variant-id]');
  var currentPrice = section.querySelector('[data-wb-current-price]');
  var comparePrice = section.querySelector('[data-wb-compare-price]');
  var weightRow = section.querySelector('[data-wb-weight-row]');
  var weightValue = section.querySelector('[data-wb-variant-weight]');
  var qty = section.querySelector('[data-wb-qty]');
  var minus = section.querySelector('[data-wb-qty-minus]');
  var plus = section.querySelector('[data-wb-qty-plus]');
  var addButton = section.querySelector('[data-wb-add]');
  var buyButton = section.querySelector('[data-wb-buy-now]');
  var shortcut = section.querySelector('[data-wb-buy-shortcut]');
  var status = section.querySelector('[data-wb-status]');
  if (!form) return;

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, form.getAttribute('data-money-format'));
    }
    return '$ ' + (cents / 100).toFixed(2);
  }

  function selectedOptions() {
    return optionInputs.map(function (input) { return input.value; });
  }

  function findVariant() {
    if (!product || !product.variants) return null;
    var options = selectedOptions();
    return product.variants.find(function (variant) {
      return options.every(function (option, index) {
        return variant.options[index] === option;
      });
    }) || null;
  }

  function updateQuantityButtons() {
    if (!qty) return;
    var value = Math.max(parseInt(qty.value, 10) || 1, 1);
    var max = parseInt(qty.getAttribute('max'), 10);
    qty.value = value;
    if (minus) minus.disabled = value <= 1;
    if (plus) plus.disabled = Number.isFinite(max) && value >= max;
  }

  function setMedia(id) {
    mediaItems.forEach(function (item) {
      item.classList.toggle('is-active', item.getAttribute('data-wb-media') === String(id));
    });
    mediaThumbs.forEach(function (thumb) {
      thumb.classList.toggle('is-active', thumb.getAttribute('data-wb-media-thumb') === String(id));
    });
  }

  function applyVariant(variant) {
    var available = !!(variant && variant.available);
    if (variantInput && variant) variantInput.value = variant.id;
    if (currentPrice && variant) currentPrice.textContent = formatMoney(variant.price);
    if (comparePrice && variant) {
      comparePrice.textContent = formatMoney(variant.compare_at_price || 0);
      comparePrice.hidden = !(variant.compare_at_price && variant.compare_at_price > variant.price);
    }
    if (weightRow && weightValue && variant) {
      weightValue.textContent = variant.weight_label || '';
      weightRow.hidden = !variant.weight_label;
    }
    if (qty && variant) {
      if (variant.inventory_management && variant.inventory_policy === 'deny') {
        qty.setAttribute('max', Math.max(variant.inventory_quantity, 1));
      } else {
        qty.removeAttribute('max');
      }
    }
    if (addButton) {
      addButton.disabled = !available;
      addButton.textContent = available ? 'Add to Cart' : 'Sold Out';
    }
    if (buyButton) buyButton.disabled = !available;
    if (status) status.hidden = available;
    if (variant && variant.featured_media) setMedia(variant.featured_media.id);
    updateQuantityButtons();
  }

  mediaThumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      setMedia(thumb.getAttribute('data-wb-media-thumb'));
    });
  });

  optionInputs.forEach(function (input) {
    input.addEventListener('change', function () {
      applyVariant(findVariant());
    });
  });

  if (minus) {
    minus.addEventListener('click', function () {
      qty.value = Math.max((parseInt(qty.value, 10) || 1) - 1, 1);
      updateQuantityButtons();
    });
  }

  if (plus) {
    plus.addEventListener('click', function () {
      var max = parseInt(qty.getAttribute('max'), 10);
      var next = (parseInt(qty.value, 10) || 1) + 1;
      qty.value = Number.isFinite(max) ? Math.min(next, max) : next;
      updateQuantityButtons();
    });
  }

  if (qty) qty.addEventListener('change', updateQuantityButtons);

  function addToCartThenCheckout() {
    if (!variantInput || !qty || (buyButton && buyButton.disabled)) return;
    var data = new FormData();
    data.append('id', variantInput.value);
    data.append('quantity', qty.value || '1');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: data
    }).then(function (response) {
      if (!response.ok) throw new Error('Cart add failed');
      if (window.beforesSetCartCount) {
        var current = parseInt((document.querySelector('[data-cart-count]') || {}).textContent, 10) || 0;
        window.beforesSetCartCount(current + (parseInt(qty.value, 10) || 1));
      }
      if (window.beforesUpdateCartCount) window.beforesUpdateCartCount().catch(function () {});
    }).then(function () {
      window.location.href = '/checkout';
    }).catch(function () {
      form.submit();
    });
  }

  form.addEventListener('submit', function (event) {
    event.preventDefault();
    if (!variantInput || !qty || (addButton && addButton.disabled)) return;

    var data = new FormData(form);
    if (addButton) {
      addButton.disabled = true;
      addButton.textContent = 'Adding...';
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: data
    }).then(function (response) {
      if (!response.ok) throw new Error('Cart add failed');
      if (window.beforesSetCartCount) {
        var current = parseInt((document.querySelector('[data-cart-count]') || {}).textContent, 10) || 0;
        window.beforesSetCartCount(current + (parseInt(qty.value, 10) || 1));
      }
      if (window.beforesUpdateCartCount) window.beforesUpdateCartCount().catch(function () {});
    }).then(function () {
      form.setAttribute('data-cart-state', 'added');
      if (addButton) addButton.textContent = 'Added';
      window.setTimeout(function () {
        if (addButton) {
          addButton.disabled = false;
          addButton.textContent = 'Add to Cart';
        }
      }, 1200);
    }).catch(function () {
      if (addButton) {
        addButton.disabled = false;
        addButton.textContent = 'Add to Cart';
      }
    });
  });

  if (buyButton) buyButton.addEventListener('click', addToCartThenCheckout);
  if (shortcut) shortcut.addEventListener('click', function (event) {
    event.preventDefault();
    addToCartThenCheckout();
  });

  applyVariant(findVariant() || (product && product.variants && product.variants[0]));
})();